import styled from "styled-components";
import {
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	COLOR_HOVER_LINK_LIGHT_BLUE,
} from "@website-builder/utilities-index";

export const TextWithImageWrapper = styled.div`
	padding: 30px 280px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 30px;
	}
`;

export const Header = styled.div`
	font-size: 23px;
	line-height: 24px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: ${FONT_WT_MEDIUM};
	padding-top: 10px;
	padding-bottom: 10px;
`;

export const Description = styled.div`
	font-size: 16px;
	line-height: 24px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: ${FONT_WT_LIGHT};
	a {
		color: ${COLOR_HOVER_LINK_LIGHT_BLUE};
	}
	p {
		img {
			display: block;
			margin-left: auto;
			margin-right: auto;
			padding-top: 15px;
			padding-bottom: 15px;
			max-width: 100%;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		p {
			img {
				width: 100%;
			}
		}
	}
`;
